import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { registerSW } from "virtual:pwa-register";
import "./ui/tokens.css";
import { App } from "./App.js";
import { queryClient } from "./api/query.js";
import { syncStamina } from "./world/staminaSync.js";

// Fuel refills show everywhere at once (D124).
syncStamina();

const gallery = location.pathname.replace(/\/+$/, "") === "/ui-gallery";
const UiGallery = lazy(() => import("./ui/UiGallery.js"));
if (!gallery) registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {gallery ? <Suspense fallback={null}><UiGallery /></Suspense> : <App />}
    </QueryClientProvider>
  </StrictMode>,
);
